import { create } from "@/modules/core/store"
import type { ExerciseFormikType } from "@/modules/sessions/sessionForm/blocks/exerciseBlock/exerciseFormikTypes"

type ExerciseCopyActions = {
  setExerciseToCopy: (exerciseToCopy: ExerciseFormikType) => void
  clearExerciseToCopy: () => void
}

type SessionExerciseCopyState = {
  exerciseToCopy: ExerciseFormikType | null
  actions: ExerciseCopyActions
}

const useSessionExerciseCopyStore = create<SessionExerciseCopyState>()((set) => ({
  exerciseToCopy: null,
  actions: {
    setExerciseToCopy: (exerciseToCopy: ExerciseFormikType) => set({ exerciseToCopy }),
    clearExerciseToCopy: () => set({ exerciseToCopy: null }),
  },
}))

export const useSessionExerciseCopy = () => useSessionExerciseCopyStore((state) => state.exerciseToCopy)
export const useSessionExerciseCopyActions = () => useSessionExerciseCopyStore((state) => state.actions)
